import client from './client'

const apiBasePath = '/api/admin/mst/branch/'

export default {
  detail: branchId => client.post(apiBasePath + 'detail', branchId),
  register: entryForm => client.post(apiBasePath + 'register', entryForm),
  update: entryForm => client.post(apiBasePath + 'update', entryForm),
  delete: branchId => client.post(apiBasePath + 'delete', branchId)
}
